<template>
  <div
    class="mb-4 md:flex"
    :class="labelTop ? 'flex-col' : 'items-center justify-between'"
  >
    <label
      :class="label_class ? label_class : 'md:w-1/5 text-gray-400'"
      class="w-full text-sm min-w-max"
      v-if="label"
      >{{ label }}</label
    >
    <input
      :type="type"
      :placeholder="placeholder"
      class="w-full text-sm border outline-gray-600 focus:outline focus:outline-primary pr-4 py-1.5 bg-white rounded"
      :class="[icon ? 'pl-8' : 'pl-4', input_class ? input_class : '']"
      autofocus
      :value="value"
      @input="$emit('input', $event.target.value)"
      @change="$emit('change', $event.target.value)"
      :disabled="disabled"
    />
  </div>
</template>

<script>
export default {
  name: "InputComponent",
  props: {
    icon: Boolean,
    label: String,
    label_class: String,
    input_class: String,
    placeholder: String,
    type: {
      type: String,
      default: "text",
    },
    value: String || Number,
    labelTop: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["input", "change"],
};
</script>

<style scoped></style>
